export const getRaceRoundId = (round: number, shortName: string): string => {
  const roundString = (round ?? 1).toString()

  return `#${shortName}${roundString}`
}
